import styled, { css } from 'styled-components';

const selectedCss = ({ theme, selected }) =>
  selected &&
  css`
    color: #fff;
  `;

export const StyledLabel = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--grey700);
  ${selectedCss}
`;

export const StyledTime = styled.div`
  color: var(--grey900);
  font-weight: bold;
  ${selectedCss}
`;
